import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boothTypeFilter'
})
export class BoothTypeFilterPipe implements PipeTransform {

  transform(value: any[], business_type: string): any[] {
    if (business_type !== '') {
      return value.filter(
        item => item.business_type.toLowerCase().indexOf(business_type.toLowerCase()) > -1);
      } else {
      return value;
    }
  }
}

